import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, ShoppingBagIcon, XIcon } from 'lucide-react';
import { buyers } from '../data/content';
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const CYCLE = 15000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutes, setMinutes] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    const timers: number[] = [];
    const show = () => {
      setIndex(i => (i + 1) % buyers.length);
      setMinutes(1 + Math.floor(Math.random() * 12));
      setVisible(true);
      timers.push(window.setTimeout(() => setVisible(false), VISIBLE_FOR));
    };
    timers.push(window.setTimeout(() => {
      show();
      timers.push(window.setInterval(show, CYCLE));
    }, FIRST_DELAY));
    return () => timers.forEach(t => {
      window.clearTimeout(t);
      window.clearInterval(t);
    });
  }, [dismissed]);
  const buyer = buyers[index];
  return <AnimatePresence data-id="element-44" data-mp="116mh6uhr8s61">
      {visible && !dismissed && <motion.div key={buyer.name} initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} role="status" className="fixed bottom-[92px] left-3 right-3 z-50 flex items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_18px_40px_-12px_rgba(38,17,74,0.45)] ring-1 ring-brand-100 sm:left-5 sm:right-auto sm:max-w-sm" data-id="element-45" data-mp="1fw241ze60dgg">
          <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-brand-700 text-white" data-id="element-46" data-mp="s4myzyv07i1i">
            <ShoppingBagIcon className="h-5 w-5" aria-hidden="true" data-id="element-47" data-mp="28imvt0yjyrkj" />
          </span>
          <div className="min-w-0 text-left" data-id="element-48" data-mp="23klg8q0c5adt">
            <p className="text-sm font-bold text-ink" data-id="element-49" data-mp="2aol5sgud8i4u">
              {buyer.name} <span className="font-medium text-ink-soft" data-id="element-50" data-mp="2aobhcxoyyj19">from {buyer.country}</span>
            </p>
            <p className="text-[13px] text-ink-soft" data-id="element-51" data-mp="2fltgxxh3jlwl">just purchased the 7D Apometry Protocol™</p>
            <p className="mt-0.5 flex items-center gap-1 text-[11px] font-semibold text-cta" data-id="element-52" data-mp="2knipn6gujnhi">
              <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-53" data-mp="2pl2hj96gvyrx" />
              Verified · {minutes} min ago
            </p>
          </div>
          <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-md p-1 text-ink-soft hover:text-ink" aria-label="Close notification" data-id="element-54" data-mp="1wwn42r2zhoip">
            <XIcon className="h-4 w-4" data-id="element-55" data-mp="26oj2y4cw9inz" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}